module.exports = ":host {\n  display: block;\n  height: 100%; }\n  :host .merchant-ui__container {\n    height: 100%;\n    min-height: 400px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/merchant-ui/merchant-ui.scss
// module id = m8YO
// module chunks = 12